import storage from "redux-persist/lib/storage";

export const authPersistConfig = {
  key: "protego-auth",
  storage,
};

export const carPersistConfig = {
  key: "car-quote",
  storage,
};

export const travelQuotePersistConfig = {
  key: "travel-quote",
  storage,
};

export const quoteFlowPersistConfig = {
  key: "car-quote-flow",
  storage,
};

export const personalDetailsPersistConfig = {
  key: "shared-personal-details",
  storage,
};

export const masterCoveragePersistConfig = {
  key: "master-coverage",
  storage,
};

export const persistedReduxKeys = [
  "root",
  authPersistConfig.key,
  carPersistConfig.key,
  travelQuotePersistConfig.key,
  quoteFlowPersistConfig.key,
  personalDetailsPersistConfig.key,
  masterCoveragePersistConfig.key,
];
